import { useRef } from 'react';
import { StyledSongPlayer } from './SongPlayer.styled';
import useSongPlayer from './useSongPlayer.hook';
import PlayerControls from '../PlayerControls/PlayerControls';
import Reactplayer from 'react-player';
import useDefaultCues from '../useCues';

export default function SongPlayer({
  url,
  onReady,
  onStart,
  onProgress,
  onRestart,
  forceRestart,
  playing = false,
  progressInterval = 100,
  noSeek = false,
  canPlay = true,
  cues,
  showCues,
  onCue,
  onCueEnd,
  currentCue,
  pauseOnCue,
  seekTo,
  onSeek,
  showPlaybackRate = true,
  onFullScreen,
  fullScreen,
  showControls = true,
  useCuesManager = useDefaultCues,
  customControls = null,
  canIncreasePlaybackRate = true,
  onPlayPause,
  spaceShortCut = true,
}) {
  const songRef = useRef();
  const { state, actions } = useSongPlayer({
    songRef,
    playing,
    onReady,
    onStart,
    onRestart,
    onProgress,
    forceRestart,
    seekTo,
    onPlayPause,
    spaceShortCut,
  });
  useCuesManager({
    currentTime: state.currentTime,
    progressInterval,
    playing: state.playing,
    cues,
    currentCue,
    onCue,
    onCueEnd,
    pauseOnCue,
    pause: actions.pause,
  });
  return (
    <>
      <StyledSongPlayer showControls={showControls}>
        <div className="player-wrapper">
          {state.isBrowser ? (
            <Reactplayer
              ref={songRef}
              className="react-player"
              url={url}
              playing={state.playing}
              controls={false}
              progressInterval={progressInterval}
              height="50px"
              width="100%"
              onStart={actions.onStart}
              onProgress={actions.onProgress}
              onSeek={(time) => {
                if (onSeek) onSeek(time);
              }}
              onDuration={actions.onDuration}
              onReady={actions.onReadyToPlay}
              onPlay={showControls ? actions.play : undefined}
              onPause={showControls ? actions.pause : undefined}
              playbackRate={state.playbackRate}
              onError={(e) => console.error('Error playing song', e)}
            />
          ) : null}
          {showControls && (
            <PlayerControls
              className="player-controls"
              duration={state.duration}
              currentTime={state.currentTime}
              bufferTime={state.bufferTime}
              ready={state.ready && canPlay}
              playing={state.playing}
              volume={state.volume}
              onPlay={actions.play}
              onPause={actions.pause}
              onSeek={noSeek ? () => {} : actions.seek}
              noSeek={noSeek}
              supportFullScreen={false}
              theme="inverted"
              cues={cues}
              currentCue={currentCue?.id}
              showCues={showCues}
              showPlaybackRate={showPlaybackRate}
              onChangePlaybackRate={actions.changePlaybackRate}
              onFullScreen={onFullScreen}
              fullScreen={fullScreen}
              canIncreasePlaybackRate={canIncreasePlaybackRate}
            />
          )}
        </div>
      </StyledSongPlayer>
      {customControls ? customControls(actions) : null}
    </>
  );
}
